import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { PublicAuthProvider } from './context/PublicAuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MainLayout from './pages/MainLayout';
import PublicScheduling from './pages/public/PublicScheduling';
import PublicMenuPage from './pages/public/PublicMenuPage';
import MagicLinkCallback from './pages/public/MagicLinkCallback';
import ClientProfilePage from './pages/public/ClientProfilePage';
import Login from './pages/Login';
import RegisterTenant from './pages/RegisterTenant';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { OnboardingWizard } from './components/onboarding/OnboardingWizard';
import { AlertProvider } from './context/AlertContext';
import { MAIN_DOMAIN } from './config';

function App() {
  const isMainDomain = window.location.hostname === MAIN_DOMAIN;

  return (
    <Router>
      <AuthProvider>
        <PublicAuthProvider>
          <AlertProvider>
            <Routes>
              {isMainDomain ? (
                <>
                  <Route path="/register" element={<RegisterTenant />} />
                  <Route path="*" element={<Navigate to="/register" replace />} />
                </>
              ) : (
                <>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />

                  {/* Public Routes */}
                  <Route path="/public/schedule" element={<PublicScheduling />} />
                  <Route path="/public/menu" element={<PublicMenuPage />} />
                  <Route path="/public/auth-callback" element={<MagicLinkCallback />} />
                  <Route path="/public/profile" element={<ClientProfilePage />} />

                  {/* Protected Routes */}
                  <Route path="/onboarding" element={
                    <ProtectedRoute>
                      <OnboardingWizard />
                    </ProtectedRoute>
                  } />

                  {/* Main Layout handles sub-routes */}
                  <Route path="/*" element={
                    <ProtectedRoute>
                      <MainLayout />
                    </ProtectedRoute>
                  } />
                </>
              )}
            </Routes>
          </AlertProvider>
        </PublicAuthProvider>
      </AuthProvider>
    </Router>
  );
}


export default App;
